import React from 'react';
import binarySearchContent from './AlgoPageContent/binary-search/content.jsx';
import bubbleSortContent from './AlgoPageContent/bubble-sort/content.jsx';
import selectionSortContent from './AlgoPageContent/selection-sort/content.jsx';
import insertionSortContent from './AlgoPageContent/insertion-sort/content.jsx';

const textMap = {    
            'binary-search': binarySearchContent,
            'bubble-sort':  bubbleSortContent,
            'selection-sort': selectionSortContent,
            'insertion-sort': insertionSortContent,
};

export default textMap; 



// WEBPACK FOOTER //
// ./src/algoTexts.jsx